import { Distance } from '@/components/distance';
import { ProviderLocation } from '@/features/profile/profile.types';
import { CELEBRUS_APPOINTMENT_LOCATION_CLASSNAMES } from '@/lib/constants';

interface AppointmentLocationProps {
  location: ProviderLocation;
}

export const AppointmentLocation = ({ location }: AppointmentLocationProps): JSX.Element => {
  return (
    <>
      <div className={`mb-0 ${CELEBRUS_APPOINTMENT_LOCATION_CLASSNAMES}`}>{location?.name}</div>
      <p className="mb-0">{location?.street}</p>
      <p className="mb-0">
        {location?.city}, {location?.state} {location?.zip}
      </p>
      <Distance distance={location.distance} showIcon />
    </>
  );
};
